/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_ArchivedInputs */



/**
* | output |
* | --- |
* | "Space archived from your list." |
*
* @param {Spaces_Toast_ArchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_archived = /** @type {((inputs?: Spaces_Toast_ArchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_ArchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space aus Ihrer Liste archiviert.")
	return /** @type {LocalizedString} */ ("Space archived from your list.")
});